import { Component } from 'react';
import AMS from '@ui/components/ams';
import { pushPageViewEvent } from '@lib/atm';
import { withServerSideProps } from '@lib/withServerSideProps';
import { howItWorksPageQuery } from '@queries/pages/howItWorks';
import Page from '@ui/components/ams/Pages/Page';

const PAGE_NAME = 'how-it-works';

class HowItWorksPage extends Component {
  componentDidMount() {
    const {
      userSessionData: {
        userData,
      },
      locale,
      pageData,
    } = this.props;

    const {
      pageTitle,
    } = pageData.howItWorksPage || {};

    pushPageViewEvent(
      window,
      userData,
      {
        locale,
        title: pageTitle,
        sections: [PAGE_NAME],
      },
    );
  }

  render() {
    const {
      globalPageData,
      pageData,
      userSessionData,
      requestData,
    } = this.props;

    const {
      howItWorksPage = {},
    } = pageData;

    const {
      metaDescription,
      pageTitle,
    } = howItWorksPage;

    return (
      <Page
        analyticsPageName={PAGE_NAME}
        pageTitle={pageTitle}
        metaDescription={metaDescription}
        globalPageData={globalPageData}
        requestData={requestData}
        userSessionData={userSessionData}
      >
        <AMS.HowItWorksPageContent
          howItWorksPageData={howItWorksPage}
          pageTitle={pageTitle}
        />
      </Page>
    );
  }
}

export const getServerSideProps = withServerSideProps({
  pageQuery: howItWorksPageQuery,
});

export default HowItWorksPage;
